import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaExchangeAlt, FaSearch, FaHistory, FaCheckCircle, FaArrowRight, FaBoxes, FaWarehouse, FaArrowLeft } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.alquilacarbolivia.com/api';

const Transferencias = ({ sucursalId, user, goBack }) => {
    const [sucursales] = useState([
        { id: 1, nombre: 'COMO EN CASA', color: '#D31027' },
        { id: 2, nombre: 'YUM YUM SC1', color: '#11998e' },
        { id: 3, nombre: 'YUM YUM SC2', color: '#f7971e' }
    ]);
    
    const [sucursalOrigen, setSucursalOrigen] = useState(parseInt(sucursalId));
    const [sucursalDestino, setSucursalDestino] = useState('');
    const [itemsOrigen, setItemsOrigen] = useState([]);
    const [itemsDestino, setItemsDestino] = useState([]);
    const [itemOrigenSeleccionado, setItemOrigenSeleccionado] = useState(null);
    const [itemDestinoSeleccionado, setItemDestinoSeleccionado] = useState(null);
    const [cantidad, setCantidad] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [historial, setHistorial] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tab, setTab] = useState('transferir');
    const [busquedaOrigen, setBusquedaOrigen] = useState('');
    const [busquedaDestino, setBusquedaDestino] = useState('');
    
    useEffect(() => {
        cargarItemsOrigen();
        cargarHistorial();
    }, [sucursalOrigen]);
    
    useEffect(() => {
        if (sucursalDestino) {
            cargarItemsDestino();
        }
    }, [sucursalDestino]);
    
    const cargarItemsOrigen = async () => {
        try {
            const res = await axios.get(`${API_URL}/transferencias/items/${sucursalOrigen}`);
            setItemsOrigen(res.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const cargarItemsDestino = async () => {
        try {
            const res = await axios.get(`${API_URL}/transferencias/items/${sucursalDestino}`);
            setItemsDestino(res.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const cargarHistorial = async () => {
        try {
            const res = await axios.get(`${API_URL}/transferencias/historial/${sucursalOrigen}`);
            setHistorial(res.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };
    
    const handleTransferir = async () => {
        if (!itemOrigenSeleccionado || !itemDestinoSeleccionado || !cantidad || !sucursalDestino) {
            Swal.fire('Error', 'Complete todos los campos', 'error');
            return;
        }
        
        const cantidadNum = parseFloat(cantidad);
        
        if (isNaN(cantidadNum) || cantidadNum <= 0) {
            Swal.fire('Error', 'La cantidad debe ser un número mayor a 0', 'error');
            return;
        }
        
        if (cantidadNum > parseFloat(itemOrigenSeleccionado.cantidad)) {
            Swal.fire('Error', `Stock insuficiente. Disponible: ${itemOrigenSeleccionado.cantidad}`, 'error');
            return;
        }
        
        const result = await Swal.fire({
            title: '¿Confirmar transferencia?',
            html: `
                <div style="text-align: left; padding: 20px;">
                    <div style="background: #f8f9fa; padding: 15px; border-radius: 10px; margin-bottom: 10px;">
                        <p style="margin: 5px 0;"><strong>📦 Item:</strong> ${itemOrigenSeleccionado.nombre_insumo}</p>
                        <p style="margin: 5px 0;"><strong>📊 Cantidad:</strong> ${cantidad} ${itemOrigenSeleccionado.unidad_medida}</p>
                    </div>
                    <div style="display: flex; align-items: center; justify-content: space-between; margin: 20px 0;">
                        <div style="text-align: center; flex: 1;">
                            <div style="font-weight: bold; color: #dc3545;">📤 ${sucursales.find(s => s.id === parseInt(sucursalOrigen))?.nombre}</div>
                            <div style="font-size: 0.9em; color: #6c757d;">Stock actual: ${itemOrigenSeleccionado.cantidad}</div>
                            <div style="font-size: 0.9em; color: #dc3545;">Después: ${(parseFloat(itemOrigenSeleccionado.cantidad) - cantidadNum).toFixed(2)}</div>
                        </div>
                        <div style="font-size: 2em; color: #28a745;">→</div>
                        <div style="text-align: center; flex: 1;">
                            <div style="font-weight: bold; color: #28a745;">📥 ${sucursales.find(s => s.id === parseInt(sucursalDestino))?.nombre}</div>
                            <div style="font-size: 0.9em; color: #6c757d;">Stock actual: ${itemDestinoSeleccionado.cantidad}</div>
                            <div style="font-size: 0.9em; color: #28a745;">Después: ${(parseFloat(itemDestinoSeleccionado.cantidad) + cantidadNum).toFixed(2)}</div>
                        </div>
                    </div>
                    ${observaciones ? `<div style="background: #fff3cd; padding: 10px; border-radius: 8px; margin-top: 10px;">
                        <strong>📝 Observaciones:</strong> ${observaciones}
                    </div>` : ''}
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, transferir',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            width: '600px'
        });
        
        if (!result.isConfirmed) return;
        
        setLoading(true);
        
        try {
            const res = await axios.post(`${API_URL}/transferencias/transferir`, {
                insumo_origen_id: itemOrigenSeleccionado.id,
                insumo_destino_id: itemDestinoSeleccionado.id,
                sucursal_origen_id: sucursalOrigen,
                sucursal_destino_id: sucursalDestino,
                cantidad: cantidadNum,
                usuario_id: user.id,
                observaciones
            });
            
            Swal.fire({
                icon: 'success',
                title: '¡Transferencia exitosa!',
                html: `<div style="font-size: 1.1em;">${res.data.message}</div>`,
                timer: 3000,
                showConfirmButton: false
            });
            
            // Limpiar
            setItemOrigenSeleccionado(null);
            setItemDestinoSeleccionado(null);
            setCantidad('');
            setObservaciones('');
            setBusquedaOrigen('');
            setBusquedaDestino('');
            cargarItemsOrigen();
            cargarItemsDestino();
            cargarHistorial();
            
        } catch (error) {
            Swal.fire('Error', error.response?.data?.error || 'Error al transferir', 'error');
        } finally {
            setLoading(false);
        }
    };
    
    const itemsOrigenFiltrados = itemsOrigen.filter(item =>
        item.nombre_insumo.toLowerCase().includes(busquedaOrigen.toLowerCase())
    );
    
    const itemsDestinoFiltrados = itemsDestino.filter(item =>
        item.nombre_insumo.toLowerCase().includes(busquedaDestino.toLowerCase())
    );
    
    const getSucursalColor = (id) => sucursales.find(s => s.id === parseInt(id))?.color || '#6c757d';
    
    return (
        <div className="container-fluid p-4" style={{background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh'}}>
            {/* Botón Volver */}
            <div className="mb-3">
                <button 
                    className="btn btn-outline-secondary"
                    onClick={goBack}
                    style={{borderRadius: '10px', fontWeight: 'bold'}}
                >
                    <FaArrowLeft className="me-2" />
                    Volver al Menú
                </button>
            </div>
            
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card shadow-lg border-0" style={{borderRadius: '20px', overflow: 'hidden'}}>
                        <div className="card-header text-white py-4" style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        }}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-3">
                                    <div style={{
                                        width: '60px', height: '60px', background: 'rgba(255,255,255,0.2)',
                                        borderRadius: '15px', display: 'flex', alignItems: 'center',
                                        justifyContent: 'center', fontSize: '2rem'
                                    }}>
                                        🔄
                                    </div>
                                    <div>
                                        <h3 className="mb-0 fw-bold">Transferencias de Inventario</h3>
                                        <p className="mb-0 opacity-75">Mueve items entre sucursales de forma segura</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="card-body p-4">
                            {/* Tabs */}
                            <ul className="nav nav-pills mb-4" style={{background: '#f8f9fa', padding: '10px', borderRadius: '15px'}}>
                                <li className="nav-item flex-fill">
                                    <button 
                                        className={`nav-link ${tab === 'transferir' ? 'active' : ''} w-100`}
                                        style={{
                                            borderRadius: '10px',
                                            fontWeight: 'bold',
                                            background: tab === 'transferir' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                                            color: tab === 'transferir' ? 'white' : '#6c757d',
                                            border: 'none'
                                        }}
                                        onClick={() => setTab('transferir')}
                                    >
                                        <FaExchangeAlt className="me-2" />
                                        Realizar Transferencia
                                    </button>
                                </li>
                                <li className="nav-item flex-fill">
                                    <button 
                                        className={`nav-link ${tab === 'historial' ? 'active' : ''} w-100`}
                                        style={{
                                            borderRadius: '10px',
                                            fontWeight: 'bold',
                                            background: tab === 'historial' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                                            color: tab === 'historial' ? 'white' : '#6c757d',
                                            border: 'none'
                                        }}
                                        onClick={() => setTab('historial')}
                                    >
                                        <FaHistory className="me-2" />
                                        Historial
                                    </button>
                                </li>
                            </ul>
                            
                            {/* Tab Transferir */}
                            {tab === 'transferir' && (
                                <>
                                    {/* Selección de Sucursales */}
                                    <div className="row mb-4">
                                        <div className="col-md-5">
                                            <div className="card border-0 shadow-sm" style={{borderRadius: '15px', background: '#fff'}}>
                                                <div className="card-body">
                                                    <label className="form-label fw-bold d-flex align-items-center gap-2">
                                                        <FaWarehouse style={{color: getSucursalColor(sucursalOrigen)}} />
                                                        Sucursal Origen
                                                    </label>
                                                    <select 
                                                        className="form-select form-select-lg"
                                                        style={{borderRadius: '10px', border: `2px solid ${getSucursalColor(sucursalOrigen)}`}}
                                                        value={sucursalOrigen}
                                                        onChange={(e) => {
                                                            setSucursalOrigen(parseInt(e.target.value));
                                                            setItemOrigenSeleccionado(null);
                                                            setItemDestinoSeleccionado(null);
                                                            setBusquedaOrigen('');
                                                            setCantidad('');
                                                        }}
                                                    >
                                                        {sucursales.map(s => (
                                                            <option key={s.id} value={s.id}>{s.nombre}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-2 d-flex align-items-center justify-content-center">
                                            <div style={{
                                                fontSize: '3rem',
                                                color: '#28a745',
                                                animation: 'pulse 2s ease-in-out infinite'
                                            }}>
                                                <FaArrowRight />
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-5">
                                            <div className="card border-0 shadow-sm" style={{borderRadius: '15px', background: '#fff'}}>
                                                <div className="card-body">
                                                    <label className="form-label fw-bold d-flex align-items-center gap-2">
                                                        <FaWarehouse style={{color: sucursalDestino ? getSucursalColor(sucursalDestino) : '#6c757d'}} />
                                                        Sucursal Destino
                                                    </label>
                                                    <select 
                                                        className="form-select form-select-lg"
                                                        style={{
                                                            borderRadius: '10px',
                                                            border: `2px solid ${sucursalDestino ? getSucursalColor(sucursalDestino) : '#dee2e6'}`
                                                        }}
                                                        value={sucursalDestino}
                                                        onChange={(e) => {
                                                            setSucursalDestino(parseInt(e.target.value));
                                                            setItemDestinoSeleccionado(null);
                                                            setBusquedaDestino('');
                                                            setCantidad('');
                                                        }}
                                                    >
                                                        <option value="">Seleccione destino...</option>
                                                        {sucursales
                                                            .filter(s => s.id !== sucursalOrigen)
                                                            .map(s => (
                                                                <option key={s.id} value={s.id}>{s.nombre}</option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {sucursalDestino && (
                                        <div className="row">
                                            {/* Columna Origen */}
                                            <div className="col-md-5">
                                                <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
                                                    <div className="card-header" style={{
                                                        background: getSucursalColor(sucursalOrigen),
                                                        color: 'white',
                                                        borderRadius: '15px 15px 0 0',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        <FaBoxes className="me-2" />
                                                        Seleccionar Item de Origen
                                                    </div>
                                                    <div className="card-body">
                                                        {/* Búsqueda */}
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text" style={{borderRadius: '10px 0 0 10px', border: 'none', background: '#f8f9fa'}}>
                                                                <FaSearch />
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar item..."
                                                                value={busquedaOrigen}
                                                                onChange={(e) => setBusquedaOrigen(e.target.value)}
                                                                style={{borderRadius: '0 10px 10px 0', border: 'none', background: '#f8f9fa'}}
                                                            />
                                                        </div>
                                                        
                                                        {/* Lista de items */}
                                                        <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                                                            {itemsOrigenFiltrados.length === 0 && (
                                                                <div className="alert alert-info">
                                                                    {busquedaOrigen ? 'No se encontraron items' : 'No hay items con stock'}
                                                                </div>
                                                            )}
                                                            
                                                            {itemsOrigenFiltrados.map(item => (
                                                                <div 
                                                                    key={item.id}
                                                                    className={`card mb-2 ${itemOrigenSeleccionado?.id === item.id ? 'border-success' : ''}`}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.2s',
                                                                        borderWidth: itemOrigenSeleccionado?.id === item.id ? '3px' : '1px',
                                                                        background: itemOrigenSeleccionado?.id === item.id ? '#d4edda' : 'white'
                                                                    }}
                                                                    onClick={() => {
                                                                        setItemOrigenSeleccionado(item);
                                                                        setCantidad('');
                                                                    }}
                                                                >
                                                                    <div className="card-body py-2 px-3">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div>
                                                                                <strong>{item.nombre_insumo}</strong>
                                                                                {itemOrigenSeleccionado?.id === item.id && (
                                                                                    <FaCheckCircle className="ms-2 text-success" />
                                                                                )}
                                                                            </div>
                                                                            <span className="badge bg-success">
                                                                                {item.cantidad} {item.unidad_medida}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Columna Centro - Detalles */}
                                            <div className="col-md-2 d-flex align-items-center justify-content-center">
                                                {itemOrigenSeleccionado && itemDestinoSeleccionado && cantidad && parseFloat(cantidad) > 0 && (
                                                    <div className="text-center">
                                                        <div className="badge bg-success mb-2" style={{fontSize: '1.5rem', padding: '15px'}}>
                                                            ✓
                                                        </div>
                                                        <div className="small text-muted">Listo</div>
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {/* Columna Destino */}
                                            <div className="col-md-5">
                                                <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
                                                    <div className="card-header" style={{
                                                        background: getSucursalColor(sucursalDestino),
                                                        color: 'white',
                                                        borderRadius: '15px 15px 0 0',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        <FaBoxes className="me-2" />
                                                        Seleccionar Item de Destino
                                                    </div>
                                                    <div className="card-body">
                                                        {/* Búsqueda */}
                                                        <div className="input-group mb-3">
                                                            <span className="input-group-text" style={{borderRadius: '10px 0 0 10px', border: 'none', background: '#f8f9fa'}}>
                                                                <FaSearch />
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar item..."
                                                                value={busquedaDestino}
                                                                onChange={(e) => setBusquedaDestino(e.target.value)}
                                                                style={{borderRadius: '0 10px 10px 0', border: 'none', background: '#f8f9fa'}}
                                                            />
                                                        </div>
                                                        
                                                        {!itemOrigenSeleccionado && (
                                                            <div className="alert alert-warning">
                                                                ⚠️ Primero seleccione un item de origen
                                                            </div>
                                                        )}
                                                        
                                                        {itemOrigenSeleccionado && (
                                                            <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                                                                {itemsDestinoFiltrados.length === 0 && (
                                                                    <div className="alert alert-info">
                                                                        {busquedaDestino ? 'No se encontraron items' : 'No hay items disponibles'}
                                                                    </div>
                                                                )}
                                                                
                                                                {itemsDestinoFiltrados.map(item => (
                                                                    <div 
                                                                        key={item.id}
                                                                        className={`card mb-2 ${itemDestinoSeleccionado?.id === item.id ? 'border-primary' : ''}`}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s',
                                                                            borderWidth: itemDestinoSeleccionado?.id === item.id ? '3px' : '1px',
                                                                            background: itemDestinoSeleccionado?.id === item.id ? '#cfe2ff' : 'white'
                                                                        }}
                                                                        onClick={() => {
                                                                            setItemDestinoSeleccionado(item);
                                                                        }}
                                                                    >
                                                                        <div className="card-body py-2 px-3">
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <strong>{item.nombre_insumo}</strong>
                                                                                    {itemDestinoSeleccionado?.id === item.id && (
                                                                                        <FaCheckCircle className="ms-2 text-primary" />
                                                                                    )}
                                                                                </div>
                                                                                <span className="badge bg-info">
                                                                                    {item.cantidad} {item.unidad_medida}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Panel de Confirmación */}
                                    {itemOrigenSeleccionado && itemDestinoSeleccionado && (
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="card border-0 shadow-lg" style={{
                                                    borderRadius: '20px',
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white'
                                                }}>
                                                    <div className="card-body p-4">
                                                        <h5 className="fw-bold mb-4">📋 Detalles de la Transferencia</h5>
                                                        
                                                        <div className="row">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label fw-bold">Cantidad a Transferir *</label>
                                                                <input 
                                                                    type="number" 
                                                                    step="0.01"
                                                                    min="0"
                                                                    max={itemOrigenSeleccionado.cantidad}
                                                                    className="form-control form-control-lg"
                                                                    style={{
                                                                        borderRadius: '10px', 
                                                                        fontSize: '1.5rem', 
                                                                        fontWeight: 'bold',
                                                                        background: 'white',
                                                                        color: '#000'
                                                                    }}
                                                                    value={cantidad}
                                                                    onChange={(e) => setCantidad(e.target.value)}
                                                                    placeholder="0.00"
                                                                    autoFocus
                                                                />
                                                                <small className="text-white">
                                                                    Disponible: <strong>{itemOrigenSeleccionado.cantidad} {itemOrigenSeleccionado.unidad_medida}</strong>
                                                                </small>
                                                            </div>
                                                            
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label fw-bold">Observaciones</label>
                                                                <textarea 
                                                                    className="form-control"
                                                                    rows="3"
                                                                    style={{borderRadius: '10px'}}
                                                                    value={observaciones}
                                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                                    placeholder="Motivo de la transferencia (opcional)"
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <button 
                                                            className="btn btn-light btn-lg w-100 fw-bold"
                                                            style={{borderRadius: '15px', fontSize: '1.2rem'}}
                                                            onClick={handleTransferir}
                                                            disabled={loading || !cantidad || parseFloat(cantidad) <= 0}
                                                        >
                                                            {loading ? '⏳ Procesando...' : '✓ Confirmar Transferencia'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            
                            {/* Tab Historial */}
                            {tab === 'historial' && (
                                <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead style={{background: '#f8f9fa'}}>
                                                    <tr>
                                                        <th>Fecha</th>
                                                        <th>Tipo</th>
                                                        <th>Item</th>
                                                        <th>Cantidad</th>
                                                        <th>Origen</th>
                                                        <th>Destino</th>
                                                        <th>Usuario</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {historial.length === 0 && (
                                                        <tr>
                                                            <td colSpan="8" className="text-center text-muted py-5">
                                                                <div style={{fontSize: '3rem', opacity: 0.3}}>📦</div>
                                                                <div>No hay transferencias registradas</div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {historial.map(t => (
                                                        <tr key={t.id}>
                                                            <td className="small">
                                                                {new Date(t.fecha).toLocaleString('es-BO')}
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${t.tipo === 'salida' ? 'bg-warning' : 'bg-success'}`}>
                                                                    {t.tipo === 'salida' ? '📤 Salida' : '📥 Entrada'}
                                                                </span>
                                                            </td>
                                                            <td className="fw-bold">{t.item_nombre}</td>
                                                            <td className="fw-bold text-primary">
                                                                {t.cantidad} {t.unidad_medida}
                                                            </td>
                                                            <td><small className="badge bg-secondary">{t.sucursal_origen}</small></td>
                                                            <td><small className="badge bg-info">{t.sucursal_destino}</small></td>
                                                            <td><small>{t.usuario_nombre}</small></td>
                                                            <td><small className="text-muted">{t.observaciones}</small></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            
            <style>{`
                @keyframes pulse {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }
            `}</style>
        </div>
    );
};

export default Transferencias;
